import { render, staticRenderFns } from "./HostingInstitutions.vue?vue&type=template&id=1ba4c00c"
import script from "./HostingInstitutions.vue?vue&type=script&lang=js"
export * from "./HostingInstitutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports